<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-printer-3d-nozzle</v-icon>{{$t('profile.nozzle.materials')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <NozzleMaterialForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import NozzleMaterialForm from '../../components/nozzlematerial/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'NozzleMaterial';

const { mapFields } = createHelpers({
  getterType: 'nozzlematerial/getField',
  mutationType: 'nozzlematerial/updateField'
});

export default {
  name: 'NozzleMaterialCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    NozzleMaterialForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('nozzlematerial', ['create', 'reset'])
  }
};
</script>
